module.exports = __webpack_public_path__ + "static/media/storeemart.f0e8a1e8.png";